import React, { useState, useEffect } from "react";
import styles from './Checkbox.module.less';
export function Checkbox({ onChange, value: inputValue = false, labelPlacement = 'left', tabindex = 0, children }) {
    const [checked, check] = useState(inputValue);
    useEffect(() => {
        inputValue && check(inputValue);
    }, [inputValue]);
    return (React.createElement("span", { className: styles.root, "data-checked": checked, "data-placement": labelPlacement, onClick: () => { onChange(!checked); check(!checked); }, tabIndex: tabindex },
        React.createElement("i", null,
            React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 -960 960 960" }, checked && React.createElement("path", { d: "M382-253.85 168.62-467.23 211.38-510 382-339.38 748.62-706l42.76 42.77L382-253.85Z" }))),
        React.createElement("span", null, children)));
}
